import { styled, useTheme } from "@mui/material/styles";
import MuiTableHead, { TableHeadProps } from "@mui/material/TableHead";
import React, { useEffect, useState } from "react";
import { TableRowRoot } from "./TableRowRoot";
import CustomCheckBox from "../../library/base/custom-checkbox";
import Box from "@mui/material/Box";
import {
  SortingDownArrowIcon,
  SortingUpArrowIcon,
  VerticalArrowsIcon,
} from "components/icons";
import { IconButton, Stack, SxProps, Theme } from "@mui/material";
import { StyledTableCell } from "./StyledTableCell";
import { convertStringToSentenceCase } from "utilz/helpers";

type HeaderProps = {
  name: string;
  sortable?: boolean;
  key: string;
  numeric?: boolean;
};

interface CustomTableHeadProps extends TableHeadProps {
  headers: Array<HeaderProps>;
  onAllSelect?: (currentState: "checked" | "unchecked") => void;
  onSortingClick?: (column: string, meta?: any) => void;
  sortProps?: {
    activeColumn: string;
    activeDirection: "asc" | "desc";
  };
  selectedItems?: Array<string>;
  multiselect?: boolean;
  cellProps?: any;
  headerCellStyles?: SxProps<Theme>;
  headerCellBuilders?: Record<string, (headerdata?: any) => React.ReactNode>;
  isAllSelected?: boolean;
}
export const TableHeadRoot = ({
  headers,
  onAllSelect,
  onSortingClick,
  sortProps,
  multiselect = true,
  cellProps,
  selectedItems,
  headerCellStyles,
  headerCellBuilders,
  isAllSelected,
  ...rest
}: CustomTableHeadProps) => {
  const [isAllItemsSelected, setIsAllItemsSelected] = useState(isAllSelected);

  useEffect(() => {
    setIsAllItemsSelected(isAllSelected);
  }, [isAllSelected]);

  const theme = useTheme();

  const HandleCheckboxClick = () => {
    onAllSelect &&
      onAllSelect(!isAllItemsSelected === true ? "checked" : "unchecked");
  };
  return (
    <TableHeadStyled {...rest}>
      <TableRowRoot header>
        {multiselect ? (
          <StyledTableCell
            sx={{ paddingLeft: "16px", width: "45px", ...headerCellStyles }}
          >
            <CustomCheckBox
              varient="primary"
              onClick={HandleCheckboxClick}
              checked={isAllItemsSelected}
            />
          </StyledTableCell>
        ) : null}

        {headers.map((headCell) => (
          <StyledTableCell
            sx={{
              padding: "6px 16px",
              whiteSpace: "nowrap",
              ...theme.typography.caption,
              "& .sort-button": {
                visibility:
                  sortProps?.activeColumn === headCell.key
                    ? "visible"
                    : "hidden",
              },
              "&:hover": {
                "& .sort-button": {
                  visibility: "visible",
                },
              },
              ...cellProps?.[headCell.key]?.sx,
              ...headerCellStyles,
            }}
            key={headCell.name}
            align={headCell.numeric ? "right" : "left"}
            // padding={headCell.disablePadding ? "none" : "normal"}
            // sortDirection={orderBy === headCell.id ? order : false}
          >
            {headerCellBuilders && headerCellBuilders[headCell.key] ? (
              headerCellBuilders[headCell.key](headCell)
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {convertStringToSentenceCase(headCell.name)}
                {/* 
                  Sorting icon behavior:
                  - For active sort column: Shows permanent blue up or down arrow icon (btn) based on sort direction
                  - For inactive columns: Shows VerticalArrowsIcon (btn) only on hover
                */}
                {headCell.sortable &&
                  (sortProps?.activeColumn === headCell.key &&
                  sortProps?.activeDirection ? (
                    <Stack
                      alignItems={"center"}
                      justifyContent={"center"}
                      onClick={() =>
                        onSortingClick && onSortingClick(headCell.key, headCell)
                      }
                    >
                      {sortProps?.activeDirection === "asc" ? (
                        <SortingUpArrowIcon
                          style={{
                            width: "16px",
                            height: "16px",
                            marginTop: "3px",
                          }}
                        />
                      ) : (
                        <SortingDownArrowIcon
                          style={{
                            width: "16px",
                            height: "16px",
                            marginTop: "3px",
                          }}
                        />
                      )}
                    </Stack>
                  ) : (
                    <>
                      <IconButton
                        className="sort-button"
                        onClick={() =>
                          onSortingClick &&
                          onSortingClick(headCell.key, headCell)
                        }
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          p: 0,
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      >
                        <VerticalArrowsIcon />
                      </IconButton>
                    </>
                  ))}
              </Box>
            )}
          </StyledTableCell>
        ))}
      </TableRowRoot>
    </TableHeadStyled>
  );
};
const TableHeadStyled = styled(MuiTableHead)<TableHeadProps>(({ theme }) => {
  return {
    ...theme.typography.caption,
    // textTransform: "capitalize",
  };
});
